<div headerOffset [ngClass]="config.sticky ? 'sticky-sidebar-container' : 'sidebar-container' ">
  <div id="sidebarContentContainer" class="sidebar-content-container" *ngIf="config != null">
      <app-sidebar-button-group [config]="config" [buttons]="config.buttons" class="w-100"></app-sidebar-button-group>
      <div *ngFor="let h of config.widgets">
          <ng-template sidebarHelper></ng-template>
      </div>
  </div>
</div>